/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#757575" d="M18.27 16L31.528 2.742a1.603 1.603 0 000-2.27c-.296-.287-.701-.463-1.146-.463s-.85.177-1.146.464L15.999 13.731 2.741.473A1.606 1.606 0 00.472 2.744l-.001-.001 13.258 13.258L.471 29.238c-.287.296-.463.701-.463 1.146s.177.85.464 1.146c.295.284.693.461 1.133.471h.002a1.69 1.69 0 001.136-.472l-.001.001L16 18.272 29.237 31.53c.294.292.699.472 1.146.472s.852-.18 1.146-.472c.287-.296.463-.701.463-1.146s-.177-.85-.464-1.146z"/>'
  }
})
